import React, { Component } from 'react'
import cx from 'classnames'
import capitalize from 'lodash/capitalize'
import concat from 'lodash/concat'
import without from 'lodash/without'
import PropTypes from 'prop-types'
import { l, DropdownPicker, Checkbox } from '@manychat/manyui'

import { formatWeekdays } from 'utils'
import { alert } from 'common/core'
import { WEEKDAYS } from 'constants/constants'

import cm from './WeekDaySelect.module.css'

const OPTIONS = WEEKDAYS.map((value) => ({ value, label: capitalize(value) }))

export default class WeekDaySelect extends Component {
  static propTypes = {
    btnProps: PropTypes.object,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    oneOrMore: PropTypes.bool,
    value: PropTypes.array,
  }

  static defaultProps = {
    value: [],
    onChange: () => {},
  }

  renderItem = (opt) => {
    const { value, oneOrMore } = this.props
    const checked = value.includes(opt.value)
    const disabled = checked && oneOrMore && value.length === 1

    return (
      <div className={cx(cm.dropdownItem, 'p-x p-y-xs text-primary')}>
        <Checkbox
          checked={checked}
          disabled={disabled}
          label={opt.label}
          className="p-events-none"
        />
      </div>
    )
  }

  select = (opt) => {
    const { name, value, onChange, oneOrMore } = this.props
    const operator = value.includes(opt.value) ? without : concat
    const newValue = operator(value, opt.value)
    newValue.sort((d1, d2) => WEEKDAYS.indexOf(d1) - WEEKDAYS.indexOf(d2))

    if (oneOrMore && newValue.length < 1) {
      return alert(l.translate('Please select at least one day'), 'danger')
    }

    onChange({ target: { value: newValue, name } })
  }

  getLabel = () => {
    const { value } = this.props
    return value ? formatWeekdays(value) : l.translate('Select days')
  }

  render() {
    const { btnProps, disabled } = this.props
    return (
      <div className={cx(cm.wrap, this.props.className)} data-test-id={'week-day-select-btn'}>
        <DropdownPicker
          label={this.getLabel()}
          disabled={disabled}
          closeOnSelect={false}
          options={OPTIONS}
          anchorProps={{ fullWidth: true, ...btnProps, className: cm.dropdownButton }}
          renderOption={this.renderItem}
          onSelect={this.select}
        />
      </div>
    )
  }
}
